export default __webpack_public_path__ + "static/media/Pro-12a.aa99294f.png";